import { render, staticRenderFns } from "./TextEditorPreview.vue?vue&type=template&id=0b74022f&"
import script from "./TextEditorPreview.vue?vue&type=script&lang=js&"
export * from "./TextEditorPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports